import React from 'react';
import {
  BaseBox,
  BaseTypography,
} from "../../Common/UI/exports";

function TBDReleaseManagement() {


    return (
      <BaseBox
        sx={{
          height: "calc(100vh - 140px)", 
          display: "flex",
          flexDirection: "column",
          maxWidth: "1160px",
          mx: "auto",
          mt: 0,
          px: 2,
        }}
      >
        <BaseTypography sx={{ fontSize: "1.2rem", mb: 0, fontWeight: 600 }}>
          Trunk-Based Development Release / Hotfix Management TBC
        </BaseTypography>
        </BaseBox>
    );
}

export default TBDReleaseManagement;
